<template>
  <div style="overflow: hidden">
    <div class="wrapper">
      <div class="add_course_head">
        <div></div>
        <div>教学视频</div>
        <div class="add_course_head_save"></div>
      </div>
      <!-- <div style="position: absolute;width:200px;right:0;z-index:999999999">
            <el-input v-model="iframeSrc" placeholder="请输入内容" ></el-input>
        </div> -->

      <div class="content">
        <div class="content_box_head flex-row" v-if="!isVideoList">
          <div class="content_search flex-row-v-center">
            <el-input
              placeholder="请输入名称"
              v-model="params.name"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="onSearch"
                style="border-radius: 50%"
              ></el-button>
            </el-input>
          </div>
          <div style="margin-left: 30px">
            <el-select
              style="width: 150px"
              v-model="params.subject_code"
              placeholder="请选择学科"
              @change="searchSubject"
              clearable
            >
              <el-option
                v-for="item in subjectList"
                :key="item.subject_code"
                :label="item.subject_name"
                :value="item.subject_code"
              >
              </el-option>
            </el-select>
          </div>
           <div style="margin-left: 30px">
            <el-select
              style="width: 150px"
              v-model="params.publish"
              placeholder="请选择教材"
              @change="searchPublish"
              clearable
            >
              <el-option
                v-for="item in publishList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div
          class="content_box_head flex-row"
          style="cursor: pointer"
          v-else
          @click="isVideoList = false"
        >
          <img src="../../assets/images/course_2.0/返回.png" alt="" />
        </div>
        <div class="course_list_box" v-if="!isVideoList">
          <div class="course_list" v-if="videoCategory.length != 0">
            <div
              class="course_card flex-col"
              v-for="(item, index) in videoCategory"
              :key="index"
              @click="getVideoList(item)"
            >
              <div class="coverBox">
                <img :src="item.cover" alt="" />
              </div>
              <div
                style="padding: 0 3px"
                class="flex-1 flex-center videoTitle"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <el-empty v-else description="暂无数据"></el-empty>
        </div>
        <div class="course_list_box" v-if="isVideoList">
          <div class="course_list" v-if="videoCategory.length != 0">
            <div
              class="course_card flex-col"
              v-for="(item, index) in videoList"
              :key="index"
              @click="openVideo(item)"
            >
              <div class="coverBox">
                <img :src="item.image" alt="" />
              </div>
              <div
                style="padding: 0 3px"
                class="flex-1 flex-center videoTitle"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <el-empty v-else description="暂无数据"></el-empty>
        </div>

        <!-- <div style="text-align: right" v-if="listTotal">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="params.page"
            :page-size="20"
            background
            layout="prev, pager, next"
            :total="listTotal"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>

    <el-dialog
      :title="video_title"
      :visible.sync="dialogVisible_previewData"
      width="70%"
      custom-class="sign_course_edit_rich_guide_dia_prew"
      :before-close="handleClose"
    >
      <iframe
        :src="video_url"
        frameborder="0"
        allowfullscreen 
        style="width: 100%; height: 60vh"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
import preventReClick from "../../config/preventReclick"; //防多次点击，重复提交
import draggable from "vuedraggable";
import previewData from "../../components/common_module/preview_data.vue";
export default {
  components: { previewData, draggable, preventReClick },
  data() {
    return {
      video_title: "",
      popover_sort_show: false,
      sort_time: "全部",
      sort_type: "时间最新",
      dialogVisible_add_material: false,
      add_material_list: [],
      options_add_material: {
        target: "",
        testChunks: false,
        allowDuplicateUploads: true,
        attrs: {
          accept: "*",
        },

        chunkSize: "1024000",
      },
      video_url: "",
      show_progress: false,
      options_add_material_attrs: { accept: ".mp4,.wmv,.avi,.flv,swf,mpg" },
      ispercentage: 0,
      name: "",
      gradeList: [],
      grade_id: "",
      subject_code: "",
      showSubject: false,
      showbtn: true,
      videoCategory: [],
      params: {
        page: 1,
        page_size: 20,
        name: "",
        subject_code: "",
        publish:"",
      },
      subjectList: [],
      listTotal: 0,
      dialogVisible_previewData: false,
      showSearchSubject: false,
      userInfo: "",
      videoList: [],
      isVideoList: false,
      publishList:[],
      
    };
  },
  filters: {
    dataFormat(input, pattern = "") {
      // 在参数列表中 通过 pattern="" 来指定形参默认值，防止报错
      var dt = new Date(input * 1000);
      // 获取年月日
      var y = dt.getFullYear();
      var m = (dt.getMonth() + 1).toString().padStart(2, "0");
      var d = dt.getDate().toString().padStart(2, "0");
      // 如果 传递进来的字符串类型，转为小写之后，等于 yyyy-mm-dd，那么就返回 年-月-日
      // 否则，就返回  年-月-日 时：分：秒
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return `${y}-${m}-${d}`;
      } else {
        // 获取时分秒
        var hh = dt.getHours().toString().padStart(2, "0");
        var mm = dt.getMinutes().toString().padStart(2, "0");
        var ss = dt.getSeconds().toString().padStart(2, "0");
        return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
      }
    },
  },
  //监听路由变化 控制首页背景图
  watch: {},
  created() {
    this.options_add_material.target =
      "https://www.gaokaowin.com:8091/cloud/upload/zoneupload?convert_now=1";
  },

  beforeMount() {},
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.userInfo);
    this.getSubjectList();
    this.getPublishList();
    this.getCategory();
  },
  methods: {
    handleClose() {
      this.video_url = "";
      this.dialogVisible_previewData = false;
    },
    onSearch() {
      this.getCategory();
    },
    //获取视频分类
    getCategory() {
      let params = {
        subject_code: this.params.subject_code,
        name: this.params.name,
        publish:this.params.publish
      };
      this.axios.post("https://shanghai.gaokaowin.com/school/video/getcategory", params).then((res) => {
        if (res.data.code == 1) {
          this.videoCategory = res.data.data;
          for (let i in this.videoCategory) {
            this.videoCategory[i].cover =
              "https://shanghai.gaokaowin.com" + this.videoCategory[i].cover;
          }
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    handleCurrentChange(val) {
      this.params.page = val;
      this.getList();
    },

    searchSubject() {
      this.getCategory();
    },
    searchPublish(){
       this.getCategory();
    },
    //获取学校的学科
    getSubjectList() {
      let params = {
        type: 3,
      };
      this.axios.post(`/student/user/subjectIconList`, params).then((res) => {
        if (res.data.code == 1) {
          this.subjectList = res.data.data;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    //
    //获取出版社列表
    getPublishList() {
      this.axios.post(`https://shanghai.gaokaowin.com/school/video/getPublish`).then((res) => {
        if (res.data.code == 1) {
          this.publishList = res.data.data;
          console.log(this.publishList)
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    //获取视频详情
    getVideoList(item) {
      let params = {
        video_category_id: item.id,
      };
      this.axios.post(`https://shanghai.gaokaowin.com/school/video/getvideo`, params).then((res) => {
        if (res.data.code == 1) {
          console.log(res.data.data);
          this.isVideoList = true;
          for (let i in res.data.data) {
            res.data.data[i].url =
              "https://shanghai.gaokaowin.com" + res.data.data[i].url;
            res.data.data[i].image =
              "https://shanghai.gaokaowin.com" + res.data.data[i].image;
          }
          this.videoList = res.data.data;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },

    //预览视频
    openVideo(item) {
      this.video_title = item.name;
      this.video_url = item.url;
      this.dialogVisible_previewData = true;
    },
  },
};
</script>
<style >
</style>
<style scoped>
.wrapper {
  margin: 14px auto;
  /* background: #ffffff; */
  height: calc(100vh - 152px);
  overflow: auto;
  border-radius: 12px;
  overflow: hidden;
  /* padding:20px 0; */
  width: 75vw;
}
.add_course_head {
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 60px;
  /* padding-top: 17px; */
  margin-bottom: 14px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(204, 204, 204, 0.5);
  border-radius: 8px;
}
.add_course_head img {
  display: block;
  width: 24px;
  height: 20px;
  margin: 20px 0;
  cursor: pointer;
}

.content {
  height: calc(100vh - 240px);
  background: #ffffff;
  padding-top: 10px;
}
.content_box_head {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  margin: 0px 16px 17px 18px;
  height: 40px;
}
.content_search {
  height: 40px;
}
.content_search >>> .el-input-group__append {
  border-radius: 0 20px 20px 0;
}
.content_search >>> .el-input__inner {
  border-radius: 20px 0 0 20px !important;
  background: #f8f8f8;
  height: 40px !important;
  font-size: 16px !important;
}
.content_search >>> .el-input {
  height: 40px;
}
.area_popper_course .popper__arrow::after {
  border-bottom-color: #ff9b36 !important;
}
.area_popper_course {
  border-color: #ff9b36;
  width: 150px;
  /* height: 400px; */
  padding-right: 0;
}
.course_creat_sort_btn {
  height: 36px;
  background: #f8f8f8;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 36px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.course_creat_sort_options > div {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 35px;
  line-height: 35px;
  width: 138px;
  cursor: pointer;
}
.course_creat_sort_options_disable {
  color: #999999 !important;
  cursor: auto !important;
}
.course_creat_sort_options_disable:nth-of-type(2n) {
  border-top: 1px solid #999999;
}
.color_active {
  color: #ff9b36 !important;
}
.creat_course {
  /* width: 78px; */
  height: 36px;
  background: #ff9b36;
  border-radius: 10px;
  line-height: 36px;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  padding: 0 10px;
}
.course_list_box {
  height: calc(100% - 80px);
  box-sizing: border-box;
  margin: 0 16px 0 18px;
  overflow: auto;
}
.course_list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.course_card {
  height: 300px;
  width: 200px;
  /* border: 4px solid #69b4ff; */
  box-shadow: 0px 4px 4px 0px rgba(3, 50, 92, 0.35);
  border-radius: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  margin-right: 20px;
  cursor: pointer;
}
.coverBox {
  box-sizing: border-box;
  width: 100%;
  height: 250px;
}
.coverBox > img {
  width: 100%;
  height: 100%;
}

.course_card_title {
  height: 30px;
  line-height: 20px;
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
}
.course_card_title_icon img {
  display: block;
}
.course_card_title_name {
  width: 130px;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  margin-left: 5px;
  margin-right: 10px;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.course_card_content_item {
  font-size: 16px;
  font-family: Microsoft YaHei;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.course_card_operation {
  display: flex;
  justify-content: space-between;
}
.course_card_operation_item {
  cursor: pointer;
}
.course_card_operation_item img {
  display: block;
  width: 26px;
  height: 26px;
}
.add_material_content_head {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #1a1a1a;
  margin: 10px 0;
}
.add_material_content_des {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #808080;
  margin: 10px 0;
}
.uploader-btn {
  height: 36px !important;
  background: #ff9b36 !important;
  border-radius: 10px !important;
  line-height: 36px;
  padding: 0 20px;
  margin: 0;
  border: 0;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.add_course_info_content_box_content_item {
  margin: 0 21px 21px 0;
  cursor: pointer;
}
.add_course_info_content_box_content {
  display: flex;
  flex-wrap: wrap;
  margin: 50px 0 30px 0;
}
.add_course_info_content_box_content_item_img {
  width: 120px;
  height: 100px;
  background: #ffffff;
  border: 1px solid #ff9b36;
  border-radius: 12px;
  position: relative;
}
.add_course_info_content_box_content_item_del {
  width: 13px;
  height: 13px;
  cursor: pointer;
  position: absolute;
  right: -6px;
  top: -6px;
}
.add_course_info_content_box_content_item_del img {
  display: block;
  width: 13px;
  height: 13px;
}
.videoTitle {
  overflow: hidden;
  text-overflow: ellipsis; /* 超出部分省略号 */
  word-break: break-all; /* break-all(允许在单词内换行。) */
  
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 显示的行数 */
  line-height: 20px;
  font-size: 14px;
}
</style>
